export interface DashboardRangeParams {
  startDate: string;
  endDate: string;
  timezone: string;
}

export function resolveDashboardTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

// The range picker returns a calendar date at local midnight. Payments treats
// endDate as an exclusive instant, so sending that value directly dropped the
// entire selected final day. Normalize to the next local midnight before the
// ISO conversion; this also keeps DST transitions calendar-correct.
export function dashboardRangeParams(
  startDate: Date,
  endDate: Date,
  timezone = resolveDashboardTimezone(),
): DashboardRangeParams {
  const endExclusive = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate() + 1,
    0,
    0,
    0,
    0,
  );
  return {
    startDate: startDate.toISOString(),
    endDate: endExclusive.toISOString(),
    timezone,
  };
}
